import {lazyLoad} from 'utils/loadable';

export const NotFoundPage = lazyLoad(
  () => import(/* webpackChunkName:'not-found-page' */ './index'),
  module => module.NotFoundPage
);
